module.exports = __webpack_public_path__ + "c2b2e47dfcaf714f1b1d2c9e786db28c.svg";